import React from 'react';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import { Reveal, Marquee } from '../components/site/Kit';
import { FinalCta } from '../components/home/Sections';

const TextImage = ({ label, title, text, image, reverse, testId }) => (
  <div className={`grid lg:grid-cols-2 gap-12 items-center ${reverse ? 'lg:[&>*:first-child]:order-2' : ''}`} data-testid={testId}>
    <Reveal>
      {label && <p className="k-label mb-4">{label}</p>}
      <h2 className="font-display font-bold text-3xl sm:text-4xl text-[#111] mb-5">{title}</h2>
      <p className="text-base md:text-lg text-[#5f6672] leading-relaxed whitespace-pre-line">{text}</p>
    </Reveal>
    <Reveal delay={0.1}><img src={image} alt={title} className="w-full h-[380px] object-cover rounded-2xl" /></Reveal>
  </div>
);

function AboutMePage() {
  const { config: c } = useSiteConfig();
  if (!c) return <div className="min-h-screen" />;

  return (
    <div className="min-h-screen" data-testid="about-me-page">
      <section className="px-4 sm:px-6 lg:px-8 pt-16 pb-24">
        <div className="max-w-6xl mx-auto">
          <Reveal className="mb-12">
            <p className="k-label mb-4">{c.me_label}</p>
            <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-[#111] max-w-3xl" data-testid="about-me-title">{c.me_title}</h1>
          </Reveal>
          <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 items-start">
            <Reveal><img src={c.me_photo} alt={c.me_intro_title} className="w-full h-[520px] object-cover rounded-2xl" data-testid="about-me-photo" /></Reveal>
            <Reveal delay={0.1} className="space-y-10 lg:pt-8">
              <div>
                <h2 className="font-display font-bold text-2xl sm:text-3xl text-[#111] mb-4">{c.me_intro_title}</h2>
                <p className="text-base md:text-lg text-[#5f6672] leading-relaxed whitespace-pre-line" data-testid="about-me-intro">{c.me_intro_text}</p>
              </div>
              <div>
                <h2 className="font-display font-bold text-2xl sm:text-3xl text-[#111] mb-4">{c.me_origin_title}</h2>
                <p className="text-base md:text-lg text-[#5f6672] leading-relaxed whitespace-pre-line">{c.me_origin_text}</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
      <Marquee items={c.marquee_items} />
      <section className="px-4 sm:px-6 lg:px-8 py-24 bg-white">
        <div className="max-w-6xl mx-auto space-y-24">
          <TextImage label={c.me_workshop_label} title={c.me_workshop_title} text={c.me_workshop_text} image={c.me_workshop_image} testId="about-me-workshop" />
          <TextImage title={c.me_design_title} text={c.me_design_text} image={c.me_design_image} reverse testId="about-me-design" />
        </div>
      </section>
      <section className="px-4 sm:px-6 lg:px-8 py-24">
        <div className="max-w-6xl mx-auto">
          <Reveal className="mb-12">
            <p className="k-label mb-4">{c.me_process_label}</p>
            <h2 className="font-display font-bold text-3xl sm:text-4xl text-[#111]">{c.me_process_title}</h2>
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[1, 2, 3, 4].map((n, i) => (
              <Reveal key={n} delay={i * 0.08}>
                <div className="border-t-2 border-[#111] pt-6" data-testid={`about-me-step-${n}`}>
                  <span className="font-mono-k text-sm text-[#7a5a2e]">0{n}</span>
                  <h3 className="font-display font-semibold text-xl text-[#111] mt-3 mb-2">{c[`me_step_${n}_title`]}</h3>
                  <p className="text-sm text-[#5f6672] leading-relaxed">{c[`me_step_${n}_text`]}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <FinalCta title={c.final_cta_title} btn={c.me_cta_btn} testId="about-me-cta" />
    </div>
  );
}

export default AboutMePage;
